import React from "react";
import { Select , Row , Col , Button} from "antd";
import { isValid, isValidArray } from "./../../../utils/utilities";
import './origin-destination.style.scss';

const {
    Option
} = Select;
const renderOrigins=(origins)=>
{
    let originsArray=[];
    if(isValidArray(origins)&&origins.length>0){
        // Add "Select All" option
        originsArray.push(<Option value="__SELECT_ALL__">Select All</Option>);
        origins.forEach(element => {
            if(isValid(element)){
                originsArray.push(<Option value={element}>{element}</Option>)
            }        
        });
    }
    return originsArray;
}

const renderDestinations=(destinations)=>
{
    let destiArray=[];
        if(isValidArray(destinations)&&destinations.length>0){
            // Add "Select All" option
            destiArray.push(<Option value="__SELECT_ALL__">Select All</Option>);
            destinations.forEach(element => {
                if(isValid(element)){
                    destiArray.push(<Option value={element}>{element}</Option>)
                }        
            });
        }
    return destiArray;
}


export const OriginDestionationFilter=({
    origins=[],
    destinations=[],
    onOriginChange=()=>{},
    onDestionationChange =()=>{},
    origin=null,
    destination=null
})=>{

    const handleOriginChange = (selectedValues) => {
        if (selectedValues.includes('__SELECT_ALL__')) {
            // If "Select All" is selected, select all origins
            const allOrigins = origins.filter(item => isValid(item));
            onOriginChange(allOrigins);
        } else {
            // Remove "__SELECT_ALL__" from the selection if it exists
            const filteredValues = selectedValues.filter(value => value !== '__SELECT_ALL__');
            onOriginChange(filteredValues);
        }
    };

    const handleDestinationChange = (selectedValues) => {
        if (selectedValues.includes('__SELECT_ALL__')) {
            // If "Select All" is selected, select all destinations
            const allDestinations = destinations.filter(item => isValid(item));
            onDestionationChange(allDestinations);
        } else {
            // Remove "__SELECT_ALL__" from the selection if it exists
            const filteredValues = selectedValues.filter(value => value !== '__SELECT_ALL__');
            onDestionationChange(filteredValues);
        }
    };

        return (
            <Row className="origin-destionation-edit-fare" >
                <Col className="origin-block">
                    <Select
                        value={origin}
                        mode="multiple"
                        size="large"
                        showSearch
                        placeholder="Select a origin"
                        optionFilterProp="children"
                        onChange={handleOriginChange}
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        bordered={true}
                        className="defalut-multi-select-style"
                        allowClear={true}
                        maxTagCount={2}
                        listHeight={180}
                        >
                        {renderOrigins(origins)}
                    </Select>
                    <Button 
                        ghost 
                        onClick={()=>{
                            onOriginChange([]);
                        }} >
                            Clear
                    </Button>
                </Col>
                <Col className="destination-block">
                    <Select
                        value={destination}
                        size="large"
                        mode="multiple"
                        showSearch
                        placeholder="Select a destination"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        onChange={handleDestinationChange}
                        bordered={true}
                        className="defalut-multi-select-style"
                        listHeight={180}
                        maxTagCount={2}
                    >
                            {renderDestinations(destinations)}
                    </Select>
                    <Button 
                        ghost 
                        onClick={()=>{
                            onDestionationChange([]);
                        }} >
                            Clear
                    </Button>
                </Col>
            </Row>  
        );
}